import * as types from '../constants/decisiondetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  decisionlookup: null,
  decisiondetails: null,
  decisiondetailsList: null,
  decisionuserList: null
}

export function decisionDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_DECISION_LOOKUP_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_DECISION_LOOKUP_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        decisionlookup: action.data
      };
    case types.FETCH_DECISION_LOOKUP_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // decisiondetailsList:action.error
      };
    case types.FETCH_DECISION_REQUEST:
      return {
        ...state,
        Status: true
      };
    case types.FETCH_DECISION_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        decisiondetails: action.data
      };
    case types.FETCH_DECISION_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // decisiondetailsList:action.error
      };
    case types.FETCH_DECISION_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        decisiondetailsList: null,
        decisiondetails: null,
      };
    case types.FETCH_DECISION_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_DECISION_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        decisiondetailsList: action.data
      };
    case types.FETCH_DECISION_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false
      };
      case types.FETCH_DECISION_USER_LIST_REQUEST:
        return {
          ...state,
          Status: true
        };
      case types.FETCH_DECISION_USER_LIST_REQUEST_COMPLETED:
        return {
          ...state,
          Status: false,
          apiGetResult: true,
          decisionuserList: action.data
        };
      case types.FETCH_DECISION_USER_LIST_REQUEST_ERROR:
        return {
          ...state,
          Status: false,
          apiGetResult: false,
          // decisiondetailsList:action.error
        };
    case types.ADD_DECISION_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_DECISION_REQUEST:
      return {
        ...state,
        Status: true
      };
    case types.ADD_DECISION_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_DECISION_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/decisiondetails.js